/**
 * BrewNectar Learn Proof — fade-up
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFadeUp(root) {
    var animated = root.querySelectorAll('.bn-lpr__animate');

    if (root.classList.contains('bn-lpr--static') || prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = root.getAttribute('data-bn-lpr-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.bnLprInit === 'true') return;
    root.dataset.bnLprInit = 'true';
    initFadeUp(root);
  }

  function initAll() {
    document.querySelectorAll('.bn-lpr').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.bn-lpr');
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.bn-lpr');
    if (root) delete root.dataset.bnLprInit;
  });
})();
